import { LOGIN_USER } from "./actionTypes";

export const loginUserAction=(data)=>{
    return{
        type:LOGIN_USER,
        payload:data
    }
}